import React from "react";
import { FormControl } from "react-bootstrap"
import Input from "@inspinia-react/form/input/input";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import CNAE from "./cnae";

import { setFancyName, setStateRegistry, setMunicipalRegistry } from "./actions";
import { mapTest } from "../../pages/products/map.test";
import { setCRT } from "./actions"

function CompanyData(props) {
  function setStateRegistry(e) {
    props.setStateRegistry(e.replace(/\D/g, ''))
  }

  function setMunicipalRegistry(e) {
    props.setMunicipalRegistry(e.replace(/\D/g, ''))
  }
  function changeCRT(e) {
    const { value } = e.target
    let [code, description] = value.split(":")
    props.setCRT({
      code,
      description: description.toLowerCase()
    })
  }

  function WithoutStateRegistry(e) {
    e.preventDefault()
    props.setStateRegistry('ISENTO')
  }
  return <div id="company-data" className='py-1'>
    <h3>Informações Fiscais</h3>
    <div data-company-data className="mb-2">
      <p>Nome Fantasia</p>
      <Input
        id={mapTest.createBranch.info.fields.inputFancyName}
        value={props.fancyName}
        placeholder="Ex: Julia Modas"
        onChange={e => props.setFancyName(e)}
      />
    </div>
    {
      props.crt
        ? <div className="form-group py-2">
          <div className="form-label">
            CRT (Código do Regime Tributáro)
          </div>
          <FormControl
            name="crt"
            onChange={changeCRT}
            as="select">
            <option selected disabled>
              Selecione
            </option>
            <option value="1:simples-nacional" >
            1 - Simples Nacional
            </option>
            <option value="2:Simples Nacional excesso de sublimite" >
            2 - Simples Nacional - excesso de sublimite da receita bruta
            </option>
            <option value="3:regime normal" >
            3 - Regime Normal
            </option>
            <option value="4:mei" >
            4 - Simples Nacional - MEI
            </option>
          </FormControl>
        </div>
        : null}
    {props.ieCnae || props.ie ?
      <div className="row">
        <div data-company-data className="py-2 col-12">
          <p>Inscrição Estadual (IE)</p>
          <Input
            id={mapTest.createBranch.info.fields.inputStateRegistry}
            value={props.stateRegistry}
            placeholder="Número da inscrição estadual"
            onChange={setStateRegistry}
          />
          <div className="row my-1 d-flex">
          <p className="ml-3">Obrigatório para emissão de NF-e</p> <a className="ml-3" href='https://dfe-portal.svrs.rs.gov.br/NFE/CCC' target='_blank'>Não sei minha Inscrição Estadual</a>
          </div>
          

          {
            props.withoutStateRegistry
              ? <a onClick={WithoutStateRegistry} href="#!" className="d-block py-2">
                Isento de Inscrição Estadual
              </a>
              : null
          }

        </div>


      </div>
      : null}
    {props.im ?
      <div className="row">
        <div data-company-data className="py-2 col-12">
          <p>Inscrição Municipal (IM)</p> 
          <Input
            value={props.municipalRegistry}
            placeholder="Número da inscrição municipal"
            onChange={setMunicipalRegistry}
          />
          <div className="row my-1 d-flex">
          <p className="ml-3">Obrigatório para emissão de NFS-e</p> <a className="ml-3" href='https://www.youtube.com/watch?v=KTHdFrTi380' target='_blank'>Não sei minha Inscrição Municipal</a>
          </div>
        </div>


      </div>
      : null}
    {props.ieCnae || props.cnae ? <CNAE /> : ""}

  </div>
}
const mapStateToProps = state => ({
  fancyName: state.fancyName,
  stateRegistry: state.stateRegistry,
  municipalRegistry: state.municipalRegistry
});

const mapDispatchToProps = dispatch => bindActionCreators({
  setFancyName,
  setStateRegistry,
  setMunicipalRegistry,
  setCRT
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CompanyData);


// WEBPACK FOOTER //
// ./src/components/parts/company-data/company-data.jsx